import { Flexbox, StatusIcon, Text } from '@luminovo/design-system';

type Status = 'info' | 'warning' | 'error';

export const StatusMessage = ({ variant, text }: { variant: Status; text: string }): JSX.Element => {
    return (
        <Flexbox
            gap={8}
            sx={{
                alignItems: 'center',
            }}
        >
            <StatusIcon status={variant} />
            <Text>{text}</Text>
        </Flexbox>
    );
};
